import { Close } from '@mui/icons-material';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import { useStore, useTheme } from '~/utils/store';

export const Toast = () => {
  const theme = useTheme();
  const toast = useStore((store) => store.toast);
  const setToast = useStore((store) => store.setToast);

  return (
    <Snackbar
      open={!!toast}
      autoHideDuration={toast?.autoHideDuration !== undefined ? toast.autoHideDuration : toast?.action ? 5000 : 4000}
      onClose={(_, reason) => {
        if (reason === 'clickaway') return;
        setToast(undefined);
      }}
      message={toast?.type ? undefined : toast?.message}
      action={
        <>
          {toast?.action && (
            <Button
              style={{
                color: theme === 'dark' ? '#d0adf0' : '#638af5',
              }}
              size="small"
              onClick={toast.action}
            >
              {toast.actionLabel}
            </Button>
          )}
          <IconButton size="small" aria-label="close" color="inherit" onClick={() => setToast(undefined)}>
            <Close fontSize="small" />
          </IconButton>
        </>
      }
      {...(toast?.type === 'error' && {
        children: (
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
            <Alert severity="error" style={{ paddingRight: '2.75rem' }}>
              {toast.message}
            </Alert>
            <IconButton
              size="small"
              aria-label="close"
              onClick={() => setToast(undefined)}
              style={{ position: 'absolute', right: '.5rem' }}
            >
              <Close fontSize="small" />
            </IconButton>
          </div>
        ),
      })}
    />
  );
};
